import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { Deps } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { from } from 'rxjs'
import { notification } from 'antd'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { updateCompanyActions, UpdateCompanyActions } from './update-company.actions'
import { UpdateCompanyState } from './update-company.reducer'
import { genericError } from 'src/utils/notifications.utils'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

type Actions = UpdateCompanyActions

interface Action$ extends ActionsObservable<Actions> {}
interface State$ extends StateObservable<UpdateCompanyState> {}

const updateCall = (dsService: DSService) => (p: {
  [startFetch]: string
  id: string
  name: string
  address: string
  postalCode: string
  city: string
  country: string
  phoneNumber: string
  groupingCode: string | null
  creatorToken: string
}) =>
  from(
    dsService
      .updateCompany({
        id: p.id,
        name: p.name,
        address: p.address,
        postalCode: p.postalCode,
        city: p.city,
        country: p.country,
        phoneNumber: p.phoneNumber,
        groupingCode: p.groupingCode,
        creatorToken: p.creatorToken
      })
      .map(updated =>
        pipe(
          updated,
          O.fold(
            () => {
              genericError()
              return updateCompanyActions.UpdateCompanyFailure({ [stopFetch]: p[startFetch] })
            },
            _updated => {
              notification.success({
                description: "L'entreprise a été mise à jour",
                message: 'Entité légale mise à jour'
              })
              return updateCompanyActions.UpdateCompanySuccess({ [stopFetch]: p[startFetch] })
            }
          )
        )
      )
  )

export const updateEpic = (action$: Action$, _s: State$, deps: Deps) =>
  action$.pipe(
    filter(updateCompanyActions.is.UpdateCompany),
    mergeMap(updateCall(deps.dsService))
  )

export const updateCompanyEpics = combineEpics(updateEpic)



// WEBPACK FOOTER //
// ./src/companies-components/update-company/update-company.epics.ts